import React, { useState, useEffect } from "react";
import axios from "axios";
import CacheBuster from 'react-cache-buster';
import appversion from '../../package.json';
import jsonData from "./ai-branding.json"; // Import the JSON file
import Footer from "./FooterNew/index";
import Banner from "./Banner/Banner";

import Body from "./Body/Body";
import Influencer from "./Influencer/influencer";
import Benefits from "./Benefits/Benefits";
import { Navbar } from "react-bootstrap";
import Navbarnew from "./Navbarnew";
// import Highlights from "./HIghlights";

// import Footer from "./Footer";

export default function Home() {
  const [summitData, setSummitData] = useState();

  const appVersion = appversion.version;
  // console.log(appVersion);

  const [links, setLinks] = useState(null);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
     setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  useEffect(() => {
    const fetchMindSummitJSON = async () => {
      await axios.get(process.env.REACT_APP_INFLUENCER).then(
        (response) => {
          console.log(response.data)
          setSummitData(response.data);
        },
        (error) => {
          console.log(error);
        }
      );
    };

    fetchMindSummitJSON();
  }, []);

  if (summitData) {
    const bannerData = summitData.banner;
    const bodyData = summitData.body;
    const influencerData = summitData.influencer;
    const benefitsData = summitData.benefits;
    // const footerData = summitData.footer;

    return (
      <>
      {bannerData ? <Navbarnew bannerData={bannerData} /> : ""}
        {bannerData ? <Banner bannerData={bannerData} /> : ""}
        {bodyData ? <Body bodyData={bodyData} /> : ""}
        {influencerData ? <Influencer influencerData={influencerData} /> : ""}
        {benefitsData ? <Benefits benefitsData={benefitsData} /> : ""}
        {/* {bodyData ?
                    <Party bodyData={bodyData} />
                : ""} */}

        <div>
          <Footer links={links}/>
        </div>
      </>
    );
  } else {
    return <></>;
  }
}
